import { render } from "./ReportServiceProviders.vue?vue&type=template&id=4f895989&scoped=true"
import script from "./ReportServiceProviders.vue?vue&type=script&lang=js"
export * from "./ReportServiceProviders.vue?vue&type=script&lang=js"

import "./ReportServiceProviders.vue?vue&type=style&index=0&id=4f895989&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f895989"]])

export default __exports__